import type { FlightMode } from '@fabricos/protocol-ts';

/**
 * User-facing flight mode label.
 *
 * `brake` becomes "HOLD" rather than "BRAKE" because the underlying mode
 * is stack-specific: ArduCopter ships it as native BRAKE (mode 17), while
 * the Hub's mode map falls PX4 back to AUTO_LOITER. Both stop the vehicle
 * and hold position without an RC throttle source. "Hold" is the operator-
 * side semantic that abstracts the difference. See ADR-0014.
 *
 * Everything else uppercases the snake_case discriminator and turns
 * underscores into spaces (e.g. `altitude_hold` → "ALTITUDE HOLD"). The
 * input is typed loosely (`string`) because the WS event payload carries
 * mode as a free-form string from the firmware decode.
 */
export function formatFlightMode(mode: string | FlightMode | undefined | null): string {
  if (!mode) return '—';
  if (mode === 'brake') return 'HOLD';
  return mode.toUpperCase().replace(/_/g, ' ');
}
